import api from './api';

export const getTiposTimesheet = async (codeType) => {
    let tipoTimesheet = null;
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        },
        params: { codeType }
    }
    try {
        const response = await api.get(`Settings/genericlist/list`, config);
        tipoTimesheet = response.data.data;
    } catch (err) { }
    return tipoTimesheet;
}
export const GetTipoTimesheetById = async (idTipoAtividade) => {
    let tipoTimesheet = null;
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        },
        params: { idTipoAtividade }
    }
    try {
        const response = await api.get(`Timesheet/atividade/` + idTipoAtividade);
        tipoTimesheet = response.data.data;
    } catch (err) { }
    return tipoTimesheet;
}